import React from 'react';
import { Space } from 'antd';
import ESSLoanDetailsView from './ESSLoanDetailsView';
import ESSEmployeeInfoView from './ESSEmployeeInfoView';
import ESSFinancialInfoView from './ESSFinancialInfoView';
import ESSTakeoverInfoView from './ESSTakeoverInfoView';
import ESSTopUpInfoView from './ESSTopUpInfoView';
import ESSQualificationAdviceView from './ESSQualificationAdviceView';
import { getActualLoanData } from './essPayload';

interface ESSLoanSummaryViewProps {
    data: any;
    formikProps?: any;
}

/**
 * Comprehensive ESS Loan Summary View
 * Displays all ESS-related information for loan approval
 */
const ESSLoanSummaryView: React.FC<ESSLoanSummaryViewProps> = ({ data, formikProps }) => {
    const loanData = getActualLoanData(data, formikProps);

    // Only show if this is an ESS loan
    const isESSLoan =
        loanData?.checkNumber ||
        loanData?.applicationNumber ||
        loanData?.essLoanApplicationNumber ||
        loanData?.essRequestPayload;

    if (!isESSLoan) {
        return null;
    }

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <ESSLoanDetailsView data={data} formikProps={formikProps} />
            <ESSEmployeeInfoView data={data} formikProps={formikProps} />
            <ESSFinancialInfoView data={data} formikProps={formikProps} />
            <ESSQualificationAdviceView data={data} formikProps={formikProps} />
            <ESSTakeoverInfoView data={data} formikProps={formikProps} />
            <ESSTopUpInfoView data={data} formikProps={formikProps} />
        </Space>
    );
};

export default ESSLoanSummaryView;
